const isTrue = value => value === true || value === 1 || value === '1' || value === 'true'

export const canCopyPageRoutePrompt = project => (
    project?.accessType === 'INTERNAL' && isTrue(project?.isOwner)
)
